import React, { Component } from "react";
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import {
  Responsive,
  Container,
  Grid,
  Image,
  Card,
  Menu,
  Segment,
  Sidebar,
  Icon,
  Checkbox,
  Label,
  Button,
  Divider,
} from "semantic-ui-react";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import "jodit";
import "jodit/build/jodit.min.css";
import JoditEditor from "jodit-react";
import Modal from "react-responsive-modal";
import cookie from "react-cookies";
import moment from "moment";
import axios from "axios";
import copy from "copy-to-clipboard";
import Config from "../../config";

const format = "YYYY-M-D";
const now = moment();
const ROOT_URL = Config.ROOT_URL;

class DashBoard extends Component {
  state = {
    userId: "",
    username: "",
    users: [],
    myevents: [],
    myblogs: [],
    files: [],
    uploaded: [],
    open: false,
    isLogin: false,
    isAdmin: false,
    showPassword: false,
    showPage: 0,
    date: new Date(),
    newgroup: "",
    content: "content",
    blogContent: "content",
    selectedEvent: {
      title: "",
      date: "",
      video: "",
      desc: "",
      htmlcontent: "",
      attend: [],
      creator: "",
    },
    selectedBlog: {
      id: "",
      title: "",
      date: moment(),
      video: "",
      desc: "",
      htmlcontent: "",
      groups: [],
      image: "",
      shownOnHomepage: 0,
      showOnBlog: 0,
      view: 0,
      creator: "",
    },
    selectedUser: {
      id: undefined,
      name: "",
      username: "",
      admin: 0,
      email: "",
      password: "",
    },
    copySuccess: "",
    groups: [],
  };

  onLoadGroups = () => {
    axios.get(`${ROOT_URL}/groups`).then((res) => {
      const results = res.data;
      this.setState({
        groups: results,
      });
    });
  };

  onOpenModal = () => {
    this.setState({ open: true, showPassword: true });
  };
  onOpenNewBlogModal = () => {
    this.setState({
      open: true,
      blogContent: "",
      selectedBlog: {
        id: "",
        title: "",
        date: moment(),
        video: "",
        desc: "",
        htmlcontent: "",
        groups: [],
        image: "",
        shownOnHomepage: 0,
        showOnBlog: 1,
        view: 0,
        creator: this.state.userId,
      },
      showPage: 2,
    });
  };
  onOpenEditBlogModal = (blogData) => {
    const blog = { ...blogData };
    blog.date = moment(blog.date);
    this.setState({
      open: true,
      blogContent: blog.htmlcontent,
      selectedBlog: blog,
      showPage: 2,
    });
  };
  onOpenEditUserModal = (user) => {
    this.setState({
      open: true,
      selectedUser: user,
      showPassword: false,
      showPage: 0,
    });
  };
  onOpenEditEventModal = (evt) => {
    var d = new Date();
    d.setFullYear(evt.date.split("-")[0]);
    d.setMonth(evt.date.split("-")[1] - 1);
    d.setDate(evt.date.split("-")[2]);
    console.log(d);
    this.setState({
      open: true,
      selectedEvent: evt,
      content: evt.htmlcontent,
      showPage: 1,
      date: d,
    });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };
  modifyBlog = () => {
    this.state.selectedBlog.htmlcontent = this.state.blogContent.toString(
      "html"
    );
    console.log(this.state.selectedBlog.id);
    if (this.state.selectedBlog.id === "") {
      const groups = Array.isArray(this.state.selectedBlog.groups)
        ? this.state.selectedBlog.groups
        : [];
      axios
        .post(`${ROOT_URL}/blog/create`, {
          username: this.state.username,
          userId: this.state.userId,
          date: this.state.selectedBlog.date.format("YYYY-M-D HH:mm"),
          image: this.state.selectedBlog.image,
          title: this.state.selectedBlog.title,
          video: this.state.selectedBlog.video,
          desc: this.state.selectedBlog.desc,
          htmlcontent: this.state.selectedBlog.htmlcontent,
          shownOnHomepage: this.state.selectedBlog.shownOnHomepage,
          showOnBlog: this.state.selectedBlog.showOnBlog,
          groups,
        })
        .then((res) => {
          const results = res.data;
          console.log(results);
          this.setState({
            open: false,
          });
          if (results) {
            this.onLoadMyBlogs();
          } else {
            console.log(res.data);

            this.setState({
              error: res.data.message,
            });
          }
        });
    } else {
      const groups = Array.isArray(this.state.selectedBlog.groups)
        ? this.state.selectedBlog.groups
        : [];
      axios
        .post(`${ROOT_URL}/blog/modify`, {
          id: this.state.selectedBlog.id,
          username: this.state.username,
          userId: this.state.userId,
          date: this.state.selectedBlog.date.format("YYYY-M-D HH:mm"),
          image: this.state.selectedBlog.image,
          title: this.state.selectedBlog.title,
          video: this.state.selectedBlog.video,
          desc: this.state.selectedBlog.desc,
          htmlcontent: this.state.selectedBlog.htmlcontent,
          shownOnHomepage: this.state.selectedBlog.shownOnHomepage,
          showOnBlog: this.state.selectedBlog.showOnBlog,
          groups,
        })
        .then((res) => {
          const results = res.data;
          console.log(results);
          this.setState({
            open: false,
          });
          if (results) {
            this.onLoadMyBlogs();
          } else {
            console.log(res.data);

            this.setState({
              error: res.data.message,
            });
          }
        });
    }
  };
  modifyEvent = () => {
    this.state.selectedEvent.htmlcontent = this.state.content.toString("html");
    var dateStr =
      this.state.date.getFullYear() +
      "-" +
      (this.state.date.getMonth() + 1) +
      "-" +
      this.state.date.getDate();
    const params = new URLSearchParams();
    params.append("username", this.state.username);
    params.append("userId", this.state.userId);
    params.append("date", dateStr);
    params.append("image", "");
    params.append("id", this.state.selectedEvent.id);
    params.append("title", this.state.selectedEvent.title);
    params.append("video", this.state.selectedEvent.video);
    params.append("desc", this.state.selectedEvent.desc);
    params.append("htmlcontent", this.state.selectedEvent.htmlcontent);

    axios.post(`${ROOT_URL}/event/modify`, params).then((res) => {
      const results = res.data;
      console.log(results);
      this.setState({
        open: false,
      });
      if (results) {
        window.location.href = "/dashboard";
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };
  onLoadUsers = () => {
    axios.get(`${ROOT_URL}/users/`).then((res) => {
      const results = res.data;
      console.log("user list", results);

      if (results.length > 0) {
        this.setState({
          users: results,
          open: false,
        });
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  onLoadMyEvents = () => {
    const params = new URLSearchParams();
    params.append("username", this.state.username);
    if (!this.state.isAdmin) {
      // admin get all blogs
      params.append("userId", this.state.userId);
    }
    axios.post(`${ROOT_URL}/event/`, params).then((res) => {
      const results = res.data;
      console.log(results);

      if (results.length > 0) {
        this.setState({
          myevents: results,
        });
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  onLoadMyBlogs = () => {
    const params = new URLSearchParams();
    params.append("username", this.state.username);
    if (!this.state.isAdmin) {
      // admin get all blogs
      params.append("userId", this.state.userId);
    }
    axios.post(`${ROOT_URL}/blog/`, params).then((res) => {
      const results = res.data;
      console.log(results);

      if (results.length > 0) {
        this.setState({
          myblogs: results,
        });
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  uploadFiles = () => {
    const filesToUpload = this.state.files;
    if (!filesToUpload) return;
    const filesArray = Array.from(filesToUpload);
    const requests = filesArray.map((file) => {
      const fileType = file.type;
      const fileName = file.name.replace(/\.[^/.]+$/, "");
      return axios.post(
        `${ROOT_URL}/file/upload?type=${fileType}&name=${encodeURIComponent(
          fileName
        )}`
      );
    });

    axios
      .all(requests)
      .then((responses) => {
        const results = [];
        const putRequests = responses.map((resp, i) => {
          const presignedUrl = resp.data.presignedUrl;
          const url = resp.data.imagePath;
          const file = filesArray[i];
          const fileType = file.type;
          results.push({ file, url });
          return axios.put(presignedUrl, file, {
            headers: {
              "Content-Type": fileType,
              "x-amz-acl": "public-read",
            },
          });
        });
        axios.all(putRequests).then(() => {
          if (results.length) {
            var files = results;
            var img = `<img src="${files[0].url}">`;
            var content = this.state.content + img;
            var blogContent = this.state.blogContent + img;
            this.setState(
              {
                uploaded: files,
                content,
                blogContent,
              },
              () => {
                console.log("state", this.state);
              }
            );
          }
        })
        .catch((e) => {
          window.alert(`Error putting image to server: ${e.message}`);
        });
      })
      .catch((e) => {
        this.setState({
          error: e.message,
        });
      });
  };

  fileChangedHandler = (event) => {
    const files = event.target.files;
    this.setState({ files: files, uploaded: [] });
  };

  copyURL = (url) => {
    copy(url);
  };

  isAdmin = () => {
    const params = new URLSearchParams();
    params.append("username", this.state.username);
    params.append("userId", this.state.userId);
    axios.post(`${ROOT_URL}/users/check`, params).then((res) => {
      const results = res.data;
      console.log("check", results, this.state, params);

      if (results) {
        if (results.isAdmin === 1) {
          this.setState({ isAdmin: true });
          this.onLoadUsers();
          this.onLoadMyEvents();
          this.onLoadMyBlogs();
        }
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  modifyUser = () => {
    const params = new URLSearchParams();
    params.append("username", this.state.selectedUser.username);
    params.append("userId", this.state.selectedUser.id);
    params.append("email", this.state.selectedUser.email);
    params.append("name", this.state.selectedUser.name);
    params.append("admin", this.state.selectedUser.admin);
    params.append("password", this.state.selectedUser.password);
    axios.post(`${ROOT_URL}/users/modify`, params).then((res) => {
      const results = res.data;
      console.log(results);

      if (results) {
        this.onLoadUsers();
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };

  newUser = () => {
    const params = new URLSearchParams();
    params.append("username", this.state.selectedUser.username);
    // params.append("userId", this.state.selectedUser.userId);
    params.append("email", this.state.selectedUser.email);
    params.append("name", this.state.selectedUser.name);
    params.append("admin", this.state.selectedUser.admin);
    params.append("password", this.state.selectedUser.password);
    axios.post(`${ROOT_URL}/users/register`, params).then((res) => {
      const results = res.data;
      console.log(results);

      if (results) {
        this.onLoadUsers();
      } else {
        console.log(res.data);

        this.setState({
          error: res.data.message,
        });
      }
    });
  };
  updateName = (evt) => {
    var selectedUser = this.state.selectedUser;
    selectedUser.name = evt.target.value;
    this.setState({
      selectedUser: selectedUser,
    });
  };
  updateUsername = (evt) => {
    var selectedUser = this.state.selectedUser;
    selectedUser.username = evt.target.value;
    this.setState({
      selectedUser: selectedUser,
    });
  };
  updateEmail = (evt) => {
    var selectedUser = this.state.selectedUser;
    selectedUser.email = evt.target.value;
    this.setState({
      selectedUser: selectedUser,
    });
  };
  updatePassword = (evt) => {
    var selectedUser = this.state.selectedUser;
    selectedUser.password = evt.target.value;
    this.setState({
      selectedUser: selectedUser,
    });
  };
  updateAdmin = (evt) => {
    var selectedUser = this.state.selectedUser;
    selectedUser.admin = evt.target.value;
    this.setState({
      selectedUser: selectedUser,
    });
  };

  updateTitle = (evt) => {
    var selectedEvent = this.state.selectedEvent;
    selectedEvent.title = evt.target.value;
    this.setState({
      selectedEvent: selectedEvent,
    });
  };
  updateVideo = (evt) => {
    var selectedEvent = this.state.selectedEvent;
    selectedEvent.video = evt.target.value;
    this.setState({
      selectedEvent: selectedEvent,
    });
  };
  updateDesc = (evt) => {
    var selectedEvent = this.state.selectedEvent;
    selectedEvent.desc = evt.target.value;
    this.setState({
      selectedEvent: selectedEvent,
    });
  };
  updateBlogTitle = (evt) => {
    var selectedBlog = this.state.selectedBlog;
    selectedBlog.title = evt.target.value;
    this.setState({
      selectedBlog: selectedBlog,
    });
  };
  updateBlogImage = (evt) => {
    var selectedBlog = this.state.selectedBlog;
    selectedBlog.image = evt.target.value;
    this.setState({
      selectedBlog: selectedBlog,
    });
  };
  updateBlogVideo = (evt) => {
    var selectedBlog = this.state.selectedBlog;
    selectedBlog.video = evt.target.value;
    this.setState({
      selectedBlog: selectedBlog,
    });
  };
  updateGroups = () => {
    var selectedBlog = this.state.selectedBlog;
    console.log(this.state.newgroup);
    if(selectedBlog.groups) {
      selectedBlog.groups.push(this.state.newgroup);
    }
    console.log(selectedBlog.groups);
    this.setState({
      selectedBlog: selectedBlog,
      newgroup: "",
    });
  };
  updateBlogNewGroup = (evt) => {
    this.setState({
      newgroup: evt.target.value,
    });
  };
  updateBlogDesc = (evt) => {
    var selectedBlog = this.state.selectedBlog;
    selectedBlog.desc = evt.target.value;
    this.setState({
      selectedBlog: selectedBlog,
    });
  };
  updateBlogShowBanner = (evt, { value }) => {
    var selectedBlog = this.state.selectedBlog;
    selectedBlog.shownOnHomepage = value;
    this.setState({
      selectedBlog: selectedBlog,
    });
  };
  updateBlogShowBlog = (evt, { value }) => {
    var selectedBlog = this.state.selectedBlog;
    selectedBlog.showOnBlog = value;
    this.setState({
      selectedBlog: selectedBlog,
    });
  };
  updateContent = (value) => {
    this.setState({ content: value });
  };
  updateBlogContent = (value) => {
    this.setState({ blogContent: value });
  };

  onChange = (date) => {
    var str = date.format("YYYY-M-D");
    console.log(str);
    var d = new Date();
    d.setFullYear(str.split("-")[0]);
    d.setMonth(str.split("-")[1] - 1);
    d.setDate(str.split("-")[2]);
    console.log(d);
    this.setState({ date: d });
  };

  constructor(props) {
    super(props);
  }
  componentDidMount() {
    var userId = cookie.load("userId");
    if (userId !== undefined) {
      if (userId !== "") {
        this.setState(
          {
            userId: userId,
            username: cookie.load("username"),
            isLogin: true,
          },
          () => {
            this.isAdmin();
            this.onLoadMyEvents();
            this.onLoadMyBlogs();
          }
        );
      }
    }

    this.onLoadGroups();
  }

  onClickUsersList = () => {
    this.setState({
      showPage: 0,
    });
  };

  onClickMyEvents = () => {
    this.setState({
      showPage: 1,
    });
  };

  onClickMyBlogs = () => {
    this.setState({
      showPage: 2,
    });
  };

  jodit;
  setRef = (jodit) => (this.jodit = jodit);

  config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
  };

  removeEvent = (eventId) => {
    axios
      .delete(`${ROOT_URL}/event/${eventId}`)
      .then((res) => {
        this.onLoadMyEvents();
      })
      .catch((error) => {
        this.setState({
          error: "Remove failed",
        });
      });
  };
  removeBlog = (blogId) => {
    axios
      .delete(`${ROOT_URL}/blog/${blogId}`)
      .then((res) => {
        this.onLoadMyBlogs();
      })
      .catch((error) => {
        this.setState({
          error: "Remove failed",
        });
      });
  };

  render() {
    return (
      <div className="Homepage">
        <Modal open={this.state.open} onClose={this.onCloseModal}>
          {this.state.showPage === 0 ? (
            <div className="">
              <p className="loginformTitle">
                {this.state.showPassword ? "New User" : "Edit User"}
              </p>
              <div className="error loginformRow">
                <p>{this.state.error}</p>
              </div>
              <div className="loginformRow">
                <input
                  name="name"
                  placeholder="Name"
                  value={this.state.selectedUser.name}
                  onChange={this.updateName}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="username"
                  placeholder="username"
                  value={this.state.selectedUser.username}
                  onChange={this.updateUsername}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="email"
                  placeholder="Email"
                  value={this.state.selectedUser.email}
                  onChange={this.updateEmail}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="password"
                  placeholder={
                    this.state.showPassword ? "Password" : "Set new password"
                  }
                  value={this.state.selectedUser.password}
                  onChange={this.updatePassword}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="admin"
                  placeholder="0: Member, 1: Admin"
                  value={this.state.selectedUser.admin}
                  onChange={this.updateAdmin}
                />
              </div>
              <div
                className="AddEventButton aligncenter"
                onClick={
                  this.state.showPassword ? this.newUser : this.modifyUser
                }
              >
                <p>Save</p>
              </div>
            </div>
          ) : this.state.showPage === 1 ? (
            <div className="">
              <p className="loginformTitle">Edit Event</p>
              <div className="error loginformRow">
                <p>{this.state.error}</p>
              </div>
              <div className="loginformRow">
                <input
                  name="title"
                  placeholder="Title"
                  value={this.state.selectedEvent.title}
                  onChange={this.updateTitle}
                />
              </div>
              <div className="loginformRow">
                <DatePicker
                  onChange={this.onChange}
                  selected={moment(this.state.date)}
                />
              </div>
              <Segment>
                <input
                  type="file"
                  name="image"
                  multiple="multiple"
                  onChange={this.fileChangedHandler}
                />
                <Button content="Upload" onClick={this.uploadFiles} />
                <Divider />
                <Card.Group>
                  {this.state.uploaded.length > 0
                    ? this.state.uploaded.map((file, index) => {
                        return (
                          <Card>
                            <Image src={file.url} size="small" />
                            <Card.Content>
                              <Card.Meta>
                                {file.url}{" "}
                                <Button
                                  content="Copy to Clipboard"
                                  onClick={() => this.copyURL(file.url)}
                                />
                              </Card.Meta>
                            </Card.Content>
                          </Card>
                        );
                      })
                    : ""}
                </Card.Group>
              </Segment>
              <div className="loginformRow">
                <input
                  name="video"
                  placeholder="Video URL"
                  value={this.state.selectedEvent.video}
                  onChange={this.updateVideo}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="desc"
                  placeholder="Description"
                  value={this.state.selectedEvent.desc}
                  onChange={this.updateDesc}
                />
              </div>
              <div className="loginformRow">
                <JoditEditor
                  editorRef={this.setRef}
                  value={this.state.content}
                  config={this.config}
                  onChange={this.updateContent}
                />
              </div>
              <div
                className="AddEventButton aligncenter"
                onClick={this.modifyEvent}
              >
                <p>Save</p>
              </div>
            </div>
          ) : (
            <div className="">
              <p className="loginformTitle">
                {this.state.selectedBlog.id === "" ? "New Blog" : "Edit Blog"}
              </p>
              <div className="error loginformRow">
                <p>{this.state.error}</p>
              </div>
              <div className="loginformRow">
                <input
                  name="title"
                  placeholder="Title"
                  value={this.state.selectedBlog.title}
                  onChange={this.updateBlogTitle}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="image"
                  placeholder="Image URL"
                  value={this.state.selectedBlog.image}
                  onChange={this.updateBlogImage}
                />
              </div>
              <div className="loginformRow">
                <div>Date:</div>
                <DatePicker
                  selected={this.state.selectedBlog.date}
                  onChange={(date) => {
                    const selectedBlog = { ...this.state.selectedBlog, date };
                    this.setState({ selectedBlog });
                  }}
                />
              </div>
              <div className="loginformRow">
                <input
                  name="video"
                  placeholder="Video URL"
                  value={this.state.selectedBlog.video}
                  onChange={this.updateBlogVideo}
                />
              </div>
              <Segment>
                <input
                  type="file"
                  name="image"
                  multiple="multiple"
                  onChange={this.fileChangedHandler}
                />
                <Button content="Upload" onClick={this.uploadFiles} />
                <Divider />
                <Card.Group>
                  {this.state.uploaded.length > 0
                    ? this.state.uploaded.map((file, index) => {
                        return (
                          <Card>
                            <Image src={file.url} size="small" />
                            <Card.Content>
                              <Card.Meta>
                                {file.url}{" "}
                                <Button
                                  content="Copy to Clipboard"
                                  onClick={() => this.copyURL(file.url)}
                                />
                              </Card.Meta>
                            </Card.Content>
                          </Card>
                        );
                      })
                    : ""}
                </Card.Group>
              </Segment>
              <div className="loginformRow">
                <input
                  name="desc"
                  placeholder="Description"
                  value={this.state.selectedBlog.desc}
                  onChange={this.updateBlogDesc}
                />
              </div>
              <div className="loginformRow">
                {this.state.selectedBlog.groups && this.state.selectedBlog.groups.map((group, index) => {
                  return (
                    <Label as="a" tag>
                      {group}
                    </Label>
                  );
                })}
                <input
                  style={{ marginTop: 16, width: 200 }}
                  name="newgroup"
                  placeholder="New Group"
                  value={this.state.newgroup}
                  onChange={this.updateBlogNewGroup}
                />
                <Button
                  style={{ marginLeft: 4, height: 50, width: 50 }}
                  content="+"
                  onClick={this.updateGroups}
                />
              </div>
              <div className="loginformRow">
                <div>Groups</div>
                {this.state.groups.map((group, index) => {
                  return (
                    <Button
                      onClick={() => {
                        var selectedBlog = { ...this.state.selectedBlog };
                        selectedBlog.groups.push(group);
                        this.setState({
                          selectedBlog: selectedBlog,
                        });
                        console.log("ff", this.state.selectedBlog);
                      }}
                      style={{ background: "transparent" }}
                    >
                      <Label as="a" tag>
                        {group}
                      </Label>
                    </Button>
                  );
                })}
              </div>
              {
                // <div className="loginformRow">
                //   <Checkbox value={this.state.selectedBlog.shownOnHomepage===0?1:0} checked={this.state.selectedBlog.shownOnHomepage === 1} label="Show in Banner" toggle onChange={this.updateBlogShowBanner}/>
                // </div>
              }
              <div className="loginformRow">
                <Checkbox
                  value={this.state.selectedBlog.showOnBlog === 0 ? 1 : 0}
                  checked={this.state.selectedBlog.showOnBlog === 1}
                  label="Show on Homepage Blogs section"
                  toggle
                  onChange={this.updateBlogShowBlog}
                />
              </div>
              <div className="loginformRow">
                <JoditEditor
                  editorRef={this.setRef}
                  value={this.state.blogContent}
                  config={this.config}
                  onChange={this.updateBlogContent}
                />
              </div>
              <div
                className="AddEventButton aligncenter"
                onClick={this.modifyBlog}
              >
                <p>Save</p>
              </div>
            </div>
          )}
        </Modal>
        <Header page="dashboard" />
        {
          // <div>Welcome, {this.state.username}</div>
        }
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation="push"
            inverted
            vertical
            visible
            width="thin"
          >
            {this.state.isAdmin ? (
              <Menu.Item as="a" onClick={this.onClickUsersList}>
                Users
              </Menu.Item>
            ) : (
              ""
            )}
            <Menu.Item as="a" onClick={this.onClickMyEvents}>
              My Events
            </Menu.Item>
            <Menu.Item as="a" onClick={this.onClickMyBlogs}>
              My Blogs
            </Menu.Item>
          </Sidebar>

          <Sidebar.Pusher>
            <Segment basic>
              <div className="homeContentWhite">
                <Container>
                  {this.state.showPage === 0 ? (
                    <div className="AboutUsTitle">Users</div>
                  ) : this.state.showPage === 1 ? (
                    <div className="AboutUsTitle">My Events</div>
                  ) : (
                    <div className="AboutUsTitle">My Blogs</div>
                  )}
                  {this.state.showPage === 0 ? (
                    this.state.isAdmin ? (
                      <div
                        className="AddEventButton"
                        onClick={this.onOpenModal}
                      >
                        <p>Add User</p>
                      </div>
                    ) : (
                      ""
                    )
                  ) : this.state.showPage === 2 ? (
                    <div
                      className="AddEventButton"
                      onClick={this.onOpenNewBlogModal}
                    >
                      <p>Add Blog</p>
                    </div>
                  ) : (
                    ""
                  )}
                  <Card.Group>
                    {this.state.showPage === 0
                      ? this.state.users.map((user, i) => {
                          return (
                            <Card>
                              <Card.Content>
                                <Card.Header>{user.name}</Card.Header>
                                <Card.Meta>
                                  <span>
                                    {user.admin === 1
                                      ? "Administrator"
                                      : "Member"}
                                  </span>
                                </Card.Meta>
                                <Card.Description>
                                  Username: {user.username}
                                  <br />
                                  Email: {user.email}
                                  <br />
                                </Card.Description>
                              </Card.Content>
                              <Card.Content extra>
                                <div
                                  className="AddEventButton aligncenter"
                                  onClick={() => this.onOpenEditUserModal(user)}
                                >
                                  <p>Edit</p>
                                </div>
                              </Card.Content>
                            </Card>
                          );
                        })
                      : this.state.showPage === 1
                      ? this.state.myevents.map((event, i) => {
                          return (
                            <Card>
                              <Card.Content>
                                <Card.Header>{event.title}</Card.Header>
                                <Card.Meta>
                                  <span>Event date: {event.date}</span>
                                </Card.Meta>
                                <Card.Description>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: event.htmlcontent,
                                    }}
                                  ></div>
                                  <div>
                                    Attendance:{" "}
                                    {Array.isArray(event.attend)
                                      ? event.attend.map((attendee, index) => {
                                          return (
                                            <span>
                                              {index ? ", " : ""}
                                              {attendee.name}
                                            </span>
                                          );
                                        })
                                      : "Nil"}
                                  </div>
                                </Card.Description>
                              </Card.Content>
                              <Card.Content extra>
                                <div
                                  className="AddEventButton aligncenter"
                                  onClick={() =>
                                    this.onOpenEditEventModal(event)
                                  }
                                >
                                  <p>Edit</p>
                                </div>
                                <div
                                  className="AddEventButton aligncenter"
                                  onClick={() => {
                                    var isConfirmRemove = window.confirm(
                                      "Confirm to remove this event?"
                                    );
                                    if (isConfirmRemove) {
                                      this.removeEvent(event.id);
                                    }
                                  }}
                                >
                                  <p>Delete</p>
                                </div>
                              </Card.Content>
                            </Card>
                          );
                        })
                      : this.state.myblogs.map((blog, i) => {
                          return (
                            <Card>
                              <Card.Content>
                                <Image src={blog.image} size="small" />
                                <Card.Header>{blog.title}</Card.Header>
                                <Card.Meta>
                                  <span>Event date: {blog.date}</span>
                                </Card.Meta>
                                <Card.Description>
                                  <div>
                                    {blog.groups
                                      ? blog.groups.map((group, index) => {
                                          return (
                                            <Label as="a" tag>
                                              {group}
                                            </Label>
                                          );
                                        })
                                      : "N/A"}
                                  </div>
                                  <div>{`${blog.desc
                                    .replace(/<(?:.|\n)*?>/gm, "")
                                    .substring(0, 30)}...`}</div>
                                </Card.Description>
                              </Card.Content>
                              <Card.Content extra>
                                <div
                                  className="AddEventButton aligncenter"
                                  onClick={() => this.onOpenEditBlogModal(blog)}
                                >
                                  <p>Edit</p>
                                </div>
                                <div
                                  className="AddEventButton aligncenter"
                                  onClick={() => {
                                    var isConfirmRemove = window.confirm(
                                      "Confirm to remove this blog?"
                                    );
                                    if (isConfirmRemove) {
                                      this.removeBlog(blog.id);
                                    }
                                  }}
                                >
                                  <p>Delete</p>
                                </div>
                              </Card.Content>
                            </Card>
                          );
                        })}
                  </Card.Group>
                </Container>
              </div>
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>

        <Footer />
      </div>
    );
  }
}

export default DashBoard;
